export class Card {
  constructor(
    public elements?: number[],
    public name?: string) {
    }
}
